import api from '../../plugins/api';

// GET /crm/cars/getDcList — список дилерских центров для выпадашки.
// Опциональные query-параметры: { cityId, mark }
const getDcList = (params) => {
  return api.get('/api/crm/cars/getDcList', params);
};

export default getDcList;
